import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {take} from 'rxjs/operators';
import {PushRegisterDto} from '../../models/server/DataTransferObject/Objects/Devices';
import {Platforms} from '../../models/server/Enums';
import {AuthenticationService, DeviceRegisterService, PatchNoteService} from '../api';
import {NotificationService} from '../notification/notification.service';
import {PlatformService} from './device/platform.service';
import {StorageKeys} from '../../models/client';
import {DeviceService} from './device/device.service';
import {Storage} from '@ionic/storage';
import {ModalController} from '@ionic/angular';
import {HtmlModalComponent} from '../../shared/components/html-modal/html-modal.component';

@Injectable({
    providedIn: 'root'
})
export class InitService {

    private isInitiliazed: boolean = false;
    private isInitiliazedSubject = new Subject();

    constructor(
        private deviceRegisterService: DeviceRegisterService,
        private notificationService: NotificationService,
        private authService: AuthenticationService,
        private platformService: PlatformService,
        private storage: Storage,
        private deviceService: DeviceService,
        private modalController: ModalController,
        private device: DeviceService,
        private patchNoteService: PatchNoteService
    ) {
    }

    public async init(forceInit: boolean = false) {
        if (this.isInitiliazed == true && forceInit == false) {
            return;
        }

        await this.authService.load();
        if (this.authService.isRegistered() !== true) {
            return;
        }

        await this.refreshToken();
        await this.initPushRegister();
        await this.checkPatchNotes();

        this.isInitiliazed = true;
        this.isInitiliazedSubject.next();
        this.isInitiliazedSubject.complete();
    }

    public async afterInit() {
        if (!this.isInitiliazed) {
            await this.isInitiliazedSubject.asObservable().pipe(take(1)).toPromise();
        }
    }

    private async refreshToken() {
        try {
            await this.authService.loginWithRefreshToken();
        } catch (err) {
            if (this.isHttpUnauthorizedError(err) == true) {
                this.authService.logout();
            }
        }
    }

    private async initPushRegister() {
        try {
            const request = new PushRegisterDto();
            request.token = await this.notificationService.register();
            request.hardwareId = await this.authService.getDeviceId();
            request.version = await this.deviceService.getAppVersion();

            if (this.platformService.isIos()) {
                request.platform = Platforms.iOS;
            }

            if (this.platformService.isAndroid()) {
                request.platform = Platforms.Android;
            }

            await this.deviceRegisterService.register(request);

            if (request.token && request.platform) {
                await this.notificationService.clearAll();
            }

        } catch (error) {
            console.error('failed device registration', error);
        }
    }

    private isHttpError(error: any): boolean {
        return error instanceof HttpErrorResponse;
    }

    private isHttpUnauthorizedError(error: any): boolean {
        return this.isHttpError(error) == true && (<HttpErrorResponse>error).status === 401;
    }

    private async checkPatchNotes() {
        const oldVersion = await this.storage.get(StorageKeys.Version);
        const newVersion = await this.device.getAppVersion();

        await this.storage.set(StorageKeys.Version, newVersion);

        if (oldVersion == null || newVersion == null || oldVersion == newVersion) {
            return;
        }

        try {
            const response = await this.patchNoteService.getLatest(newVersion, oldVersion);

            for (const patchNote of response.missedPatchNotes || []) {
                const modal = await this.modalController.create({
                    component: HtmlModalComponent,
                    componentProps: {
                        title: patchNote.title,
                        content: patchNote.content
                    }
                });

                await modal.present();
                await modal.onDidDismiss();
            }
        } catch (error) {
            console.error('failed fetching patch notes', error);
        }
    }
}
